/**
 * There are some aspects of the editor state that are not relevant for undo/redo, like hovers, selections, actions and
 * some operational properties of the nodes, like nodeRef. This function filters out those properties, so that we can
 * compare the only relevant parts of the state.
 * @param nodes
 * @returns {{nodes: {}}}
 */
export function stateSubsetForEquality({ nodes }) {
    const filteredNodes = Object.fromEntries(
        Object.entries(nodes).map(([nodeKey, nodeValue]) => {
            const { meta, styles, descendants, childNodes } = nodeValue;
            return [nodeKey, { meta, styles, descendants, childNodes }];
        }),
    );
    return { nodes: filteredNodes };
}
